import {
  INotification,
  INotificationActionContext,
  INotificationResolver,
  IResolvedDestination,
} from 'services/notifications/types'

const normalizeKey = (value?: string | null) => (value ?? '').trim().toLowerCase()

export interface INotificationEventHandler {
  eventTypes: string[]
  onBeforeNavigate?(notification: INotification, context: INotificationActionContext): Promise<void>
  resolve(notification: INotification, context: INotificationActionContext): Promise<IResolvedDestination>
}

interface ICreateServiceNotificationResolverOptions {
  id: string
  service: string
  events: INotificationEventHandler[]
  fallback: INotificationEventHandler
}

export const createServiceNotificationResolver = ({
  id,
  service,
  events,
  fallback,
}: ICreateServiceNotificationResolverOptions): INotificationResolver => {
  const getEventHandler = (notification: INotification): INotificationEventHandler => {
    const eventKey = normalizeKey(notification.event_type)

    return (
      events.find((eventHandler) =>
        eventHandler.eventTypes.some((eventType) => normalizeKey(eventType) === eventKey)
      ) ?? fallback
    )
  }

  return {
    id,
    service,
    eventTypes: events.flatMap((eventHandler) => eventHandler.eventTypes),
    async onBeforeNavigate(notification, context) {
      await getEventHandler(notification).onBeforeNavigate?.(notification, context)
    },
    async resolve(notification, context) {
      return getEventHandler(notification).resolve(notification, context)
    },
  }
}
